// extracted by mini-css-extract-plugin
export default {"image":"X1-z","loaded":"Y1-z"};